import request from '@/utils/request'
const proxyN = jsvaIPIURL // serviceURL
/* 报文模板  */
export function getTemplateList(query) {
  query.serviceID = 'getTemplateList'
  return request({
    //url: proxyN + 'template/getTemplateList',
    url: proxyN + 'gdp/getCommonDataByPage',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetTemplateList',
    method: 'post',
    data: query
  })
}

/* 测站  */
export function getStrprpList(query) {
  query.serviceID = 'Stations'
  return request({
    url: proxyN + 'gdp/getCommonDataByPage',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=Stations',
    method: 'post',
    data: query
  })
}
/* 获取用户分配测站  */
export function getAppStations(query) {
  query.serviceID = 'GetAppStations'
  return request({
    url: proxyN + 'gdp/getCommonDataByPage',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetAppStations',
    method: 'post',
    data: query
  })
}

/* 添加当前用户分配测站  */
export function addCurrentUserStrprp(data) {
  data.serviceID = 'BachAddUserStbprp'
  return request({
    url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/batchAddData/AppUserStations',
    method: 'post',
    data,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      'Content-Type': 'application/json;charset=UTF-8'

    }
  })
}
/* 添加当前用户分配测站  */
export function addCurrentUserStrprp22(data) {
  return request({
    url: proxyN + 'business/singleEditServer/batchAddData/AppUserStations',
    method: 'post',
    data,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      'Content-Type': 'application/json;charset=UTF-8'

    }
  })
}
/* 删除当前用户分配测站  */
export function deleteCurrentUserStrprp(query) {
  query.serviceID = 'DelUserStbprp'
  return request({
    url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/singleDel?serviceID=AppUserStations',
    method: 'post',
    data: query
  })
}

/* 管理单位  */
export function getLocalityList(query) {
  return request({
    url: proxyN + 'gdp/getAllDepts',
    //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetDeptments',
    method: 'get',
    params: query
  })
}
/* 获取  */
export function getSyspara(query) {
  return request({
    url: proxyN + 'business/singleServer/querySingleTB?serviceID=GetSysPara',
    method: 'get',
    params: query
  })
}

/* 获取系统参数：1.审核时间 2. */
export function getAuditInfo(query) {
  return request({
    url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetAudit',
    method: 'get',
    params: query
  })
}
/* 设置审核时间  */
export function setAuditInfo(query) {
  return request({

    // url: proxyN + '/business/multipleServer/multipleTableServer?serviceID=SetAudit ',
    url: proxyN + 'business/singleEditServer/singleUpdate?serviceID=SetSysPara', // Syspara
    method: 'get',
    params: query
  })
}
export function fetchList(query) {
  return request({
    url: jsvaIPIURL + 'System/GetUserList',
    method: 'get',
    params: query
  })
}

export function createInfo(data) {
  return request({
    url: jsvaIPIURL + 'System/AddUser',
    method: 'post',
    data
  })
}

export function updateInfo(data) {
  return request({
    url: jsvaIPIURL + 'System/UpdateUser',
    method: 'post',
    data
  })
}

/* 删除多个  */
export function deleteList(query) {
  return request({
    url: jsvaIPIURL + 'System/DeleteUserList',
    method: 'post',
    data: query
  })
}

// 日志类型和 日志内容
export function syslog(query) {
  if(query.conQuery){//20220323未序列化，中文账号出现异常
    if(query.conQuery.USERID){
      query.conQuery.USERID=decodeURIComponent(query.conQuery.USERID);
    }
    query.conQuery=JSON.stringify(query.conQuery);
  }
  return request({
    url: proxyN + 'gdp/insertSyslog',
    //url: proxyN + 'gdp/modifyCommonMethod',
    //url: proxyN + 'business/singleEditServer/singleAdd',
    method: 'post',
    data: query
  })
}
//查询日志列表
export function getSyslogList(query) {
    query.serviceID = 'GetSysLogs'
    return request({
      url: proxyN + 'gdp/getCommonDataByPage',
      //url: proxyN + 'business/multipleServer/multipleTableServer?serviceID=GetSysLogs',
      method: 'post',
      data: query
    })
  }
